import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import Button from 'components/UI/CustomButtons/Button';
import Badge from 'components/UI/Badge/Badge';
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle';
import { inboxTabValues } from 'config';

/**
 * @description
 * Constant to change inbox.
 * @param {Function} translation - Passed from HOC.
 * @returns {Array} - With the translated inbox selectors.
 */
const inboxTab = translation => [
  {
    date: translation('review_queue.inbox.today'),
    value: inboxTabValues.TODAY,
  },
  {
    date: translation('review_queue.inbox.yesterday'),
    value: inboxTabValues.YESTERDAY,
  },
  {
    date: translation('review_queue.inbox.week'),
    value: inboxTabValues.LAST_WEEK,
  },
  {
    date: translation('review_queue.inbox.previous'),
    value: inboxTabValues.PREVIOUS,
  },
];

/**
 * @description
 * Stateless component
 *
 * @param {Object} props - Props from parent.
 */
const ReviewQueueInbox = props => {
  // eslint-disable-next-line no-unused-vars
  const { classes, currentInbox, changeInbox, t, data } = props;
  return (
    <React.Fragment>
      <div className={classes.container}>
        <div className={classes.buttonGroup}>
          {inboxTab(t).map(tab => (
            <Button
              simple={tab.value !== currentInbox}
              onClick={() => changeInbox(tab)}
              color="info"
              round
              key={`inbox-btn-${tab.value}`}
              id={`inbox-btn-${tab.value}`}
            >
              {tab.date}
              <span style={{ marginLeft: 8 }}>
                <Badge
                  color={tab.value !== currentInbox ? 'warning' : 'primary'}
                >
                  {tab.value === inboxTabValues.TODAY && data.to_review_today}
                  {tab.value === inboxTabValues.YESTERDAY &&
                    data.to_review_yesterday}
                  {tab.value === inboxTabValues.LAST_WEEK &&
                    data.to_review_last_week}
                  {tab.value === inboxTabValues.PREVIOUS &&
                    data.to_review_previous}
                </Badge>
              </span>
            </Button>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

/**
 * ReviewQueueInbox PropTypes
 * @param classes - styles
 * @param data - badges count
 * @param currentInbox - current inbox
 * @param t - prop from HOC with string translations
 * @callback changeInbox - callback to change inbox tab
 */
ReviewQueueInbox.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.shape({}).isRequired,
  currentInbox: PropTypes.string.isRequired,
  changeInbox: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(
  withStyles(extendedTablesStyle)(ReviewQueueInbox),
);
